import { SET_ACTIVE_TOOLTIP } from './constants';

export const setActiveTooltip = (nodeId: string) => ({
  type: SET_ACTIVE_TOOLTIP,
  nodeId,
});
